import React from 'react';

function Price() {
  return (
    <div className="sec-box price section-padding" id="price">
      <div className="sec-head mb-80 wow fadeInUp">
        <div className="row justify-content-center">
          <div className="col-lg-6 text-center">
            <h6 className="sub-title opacity-7 mb-15">Our Workflow</h6>
            <h3>
              <span className="main-color">How We Bring</span> Ideas to Life
            </h3>
          </div>
        </div>
      </div>
      <div className="row md-marg">
        <div className="col-lg-4 valign">
          <div
            className="item full-width md-mb50 wow fadeIn"
            data-wow-delay=".2s"
          >
            <div className="top-curv">
              <span className="left"></span>
              <h6 className="type">Phase 1</h6>
              <span className="right"></span>
            </div>

            <div className="content">
              <div className="amount d-flex justify-content-center align-items-center pb-50 mb-50 bord-thin-bottom">
                <h2 className="main-color fs-3 text-center">Design & Strategy</h2>
              </div>
              <div className="feat">
                <ul className="rest">
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Understand your project goals</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Create initial wireframes</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>
                      Build visual prototypes
                    </span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Finalize design direction</span>
                  </li>
                </ul>
              </div>
              <div className="text-center mt-50">
                
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 valign">
          <div
            className="item full-width md-mb50 wow fadeIn"
            data-wow-delay=".4s"
          >
            <div className="top-curv">
              <span className="left"></span>
              <h6 className="type">Phase 2</h6>
              <span className="right"></span>
            </div>

            <div className="content">
              <div className="amount d-flex justify-content-center align-items-center pb-50 mb-50 bord-thin-bottom">
                <h2 className="main-color fs-3 text-center">Development & Integration</h2>
              </div>
              <div className="feat">
                <ul className="rest">
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Convert designs into code</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Implement front-end features</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>
                      Connect with back-end systems
                    </span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Ensure responsive performance</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Maintain clean, scalable code</span>
                  </li>
                </ul>
              </div>
              <div className="text-center mt-50">
                
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 valign">
          <div className="item full-width wow fadeIn" data-wow-delay=".6s">
            <div className="top-curv">
              <span className="left"></span>
              <h6 className="type">Phase 3</h6>
              <span className="right"></span>
            </div>

            <div className="content">
              <div className="amount d-flex justify-content-center align-items-center pb-50 mb-50 bord-thin-bottom">
                <h2 className="main-color fs-3 text-center">Testing & Delivery</h2>
              </div>
              <div className="feat">
                <ul className="rest">
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Perform complete QA testing</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Fix bugs and optimize</span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>
                      Apply client revisions
                    </span>
                  </li>
                  <li>
                    <i className="fas fa-check"></i>{' '}
                    <span>Deliver final project</span>
                  </li>
                </ul>
              </div>
              <div className="text-center mt-50">
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Price;
